import { render, staticRenderFns } from "./previewNews.vue?vue&type=template&id=6b941ff8&scoped=true&"
import script from "./previewNews.vue?vue&type=script&lang=js&"
export * from "./previewNews.vue?vue&type=script&lang=js&"
import style0 from "./previewNews.vue?vue&type=style&index=0&id=6b941ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b941ff8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
